import type { JNumber, JObject, JString } from '../types';

export interface SpotQuoteRateValidationSchema extends JObject {
  type: 'object';
  properties: {
    accessorials?: {
      type: 'array';
      items: {
        type: 'object';
        properties: {
          accessorialCode: JString;
          accessorialDescription: JString;
        };
      };
    };
    branchKey?: JNumber;
    cargoType?: JString;
    companyID?: JNumber;
    consigneeCompanyName?: JString;
    consigneeCity?: JString;
    consigneeCountry?: JString;
    consigneePortCode?: JString;
    consigneePortType?: JString;
    consigneePostalCode?: JString;
    consigneeState?: JString;
    cube?: JNumber;
    dimUOM?: JString;
    equipmentType?: JNumber;
    height?: JNumber;
    length?: JNumber;
    quoteKey?: JNumber;
    quoteNumber?: JString;
    shipDate?: JString;
    shipmentTerms?: JString;
    shipmentType?: JString;
    shipperCompanyName?: JString;
    shipperCity?: JString;
    shipperCountry?: JString;
    shipperPortCode?: JString;
    shipperPortType?: JString;
    shipperPostalCode?: JString;
    shipperState?: JString;
    transportationProvider?: JString;
    weight?: JNumber;
    weightUOM?: JString;
    width?: JNumber;
  };
}

export type SpotQuoteRateFields = keyof SpotQuoteRateValidationSchema['properties'];

export const SPOT_QUOTE_RATE_LABELS: { [K in SpotQuoteRateFields]?: string | Record<string, string> } = {
  branchKey: 'Branch',
  cargoType: 'Cargo Type',
  consigneeCity: 'City',
  consigneeCompanyName: 'Company Name',
  consigneeCountry: 'Country',
  consigneePortCode: 'Port Name',
  consigneePortType: 'Port Type',
  consigneePostalCode: 'Postal Code',
  consigneeState: 'State/Province',
  cube: 'Cube',
  dimUOM: 'Dim UOM',
  equipmentType: 'Equipment Type',
  height: 'Height',
  length: 'Length',
  quoteNumber: 'Reference Number',
  shipDate: 'Ship Date',
  shipmentTerms: 'Shipment Terms',
  shipmentType: 'Shipment Type',
  shipperCity: 'City',
  shipperCompanyName: 'Company Name',
  shipperCountry: 'Country',
  shipperPortCode: 'Port Name',
  shipperPortType: 'Port Type',
  shipperPostalCode: 'Postal Code',
  shipperState: 'State/Province',
  transportationProvider: 'Transportation Provider',
  weight: 'Weight',
  weightUOM: 'Weight UOM',
  width: 'Width',
} as const;
